import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const ForgotPasswordPage = lazy(() => import("./ForgotPasswordPage"));

const ForgotPasswordPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <ForgotPasswordPage />
    </Suspense>
  );
};

export default ForgotPasswordPageLazy;
